module.exports = __webpack_public_path__ + "img/ibook_logo.660a83f9.png";